// @ts-nocheck

import { isWeb } from "../constants";

export function initializeFacebookPixel(pixelId: string) {
  if (!isWeb) return;

  !((f, b, e, v, n, t, s) => {
    if (f.fbq) return;
    n = f.fbq = () => {
      // biome-ignore lint/complexity/noArguments: skip
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  fbq("init", pixelId); // Insert your Pixel ID here
  fbq("track", "PageView");
}
